import { packPhotos } from '../assets/menuImages';

export const packs = [
  {
    id: 'pack-anniversaire',
    name: 'Pack Anniversaire',
    emoji: '🎂',
    tagline: 'Fêtez en grand',
    desc: 'Le combo parfait pour un anniversaire mémorable — gourmand, festif et prêt à partager.',
    basePrice: 7500,
    image: packPhotos['pack-anniversaire'],
    category: 'packs',
    highlight: true,
    contents: [
      '2 burgers au choix',
      '1 crêpe Nutella à partager',
      '2 jus naturels',
      'Décoration festive incluse',
    ],
    includedIngredients: [
      { id: 'burgers', name: '2 burgers au choix' },
      { id: 'crepe', name: 'Crêpe Nutella' },
      { id: 'jus', name: '2 jus naturels' },
      { id: 'deco', name: 'Décoration festive' },
    ],
    extraIngredients: [],
  },
  {
    id: 'pack-you-and-me',
    name: 'Pack You & Me',
    emoji: '💕',
    tagline: 'Pour deux',
    desc: 'Un moment complice à deux — menus généreux, boissons fraîches et touche romantique.',
    basePrice: 5500,
    image: packPhotos['pack-you-and-me'],
    category: 'packs',
    contents: [
      '2 burgers ou tacos au choix',
      '2 boissons fraîches',
      '1 dessert crêpe à partager',
    ],
    includedIngredients: [
      { id: 'plats', name: '2 plats au choix' },
      { id: 'boissons', name: '2 boissons' },
      { id: 'dessert', name: 'Crêpe dessert à partager' },
    ],
    extraIngredients: [],
  },
  {
    id: 'pack-surprise',
    name: 'Pack Surprise',
    emoji: '🎁',
    tagline: 'Mystère gourmand',
    desc: 'Laissez-vous surprendre ! Notre chef compose un menu surprise selon vos envies du moment.',
    basePrice: 4500,
    image: packPhotos['pack-surprise'],
    category: 'packs',
    contents: [
      '1 plat surprise du chef',
      '1 accompagnement',
      '1 boisson au choix',
      'Une touche spéciale DoWhile',
    ],
    includedIngredients: [
      { id: 'plat-surprise', name: 'Plat surprise du chef' },
      { id: 'accompagnement', name: 'Accompagnement' },
      { id: 'boisson', name: 'Boisson au choix' },
    ],
    extraIngredients: [],
  },
  {
    id: 'pack-famille',
    name: 'Pack Famille',
    emoji: '👨‍👩‍👧‍👦',
    tagline: 'Pour toute la table',
    desc: 'Un assortiment généreux pour régaler toute la famille sans se ruiner.',
    basePrice: 12000,
    image: packPhotos['pack-famille'],
    category: 'packs',
    contents: [
      '4 plats au choix (burgers, tacos ou crêpes)',
      '4 boissons',
      '1 grande portion de frites à partager',
    ],
    includedIngredients: [
      { id: 'plats', name: '4 plats au choix' },
      { id: 'boissons', name: '4 boissons' },
      { id: 'frites', name: 'Frites à partager' },
    ],
    extraIngredients: [],
  },
];

export default packs;
